import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
export const NotesList = ({ notes }) => {
  return (
    <List sx={{ width: "100%", marginTop: "30px", bgcolor: "#2C2C2C" }}>
      {notes
        .filter((note) => note.cr855_date !== "" && note.cr855_note !== "")
        .map((note, index) => (
          <React.Fragment key={index}>
            <ListItem alignItems="flex-start">
              <ListItemAvatar>
                <Tooltip title={note.cr855_coach || "Unknown Coach"} arrow>
                  <Avatar sx={{ bgcolor: "#E0E0E0" }}>
                    {/* Display the first letter of coach name */}
                    {note.cr855_coach ? note.cr855_coach.charAt(0) : "?"}
                  </Avatar>
                </Tooltip>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography sx={{ color: "white" }}>
                    {/* Format date to MM-DD-YYYY */}
                    {new Date(note.cr855_date).toLocaleDateString("en-US", {
                      timeZone: "UTC",
                    })}
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{ color: "text.primary", display: "inline" }}
                    >
                      {note.cr855_note.replace(/<br ?\/?>/g, "\n")}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            {index < notes.length - 1 && (
              <Divider variant="inset" component="li" />
            )}
          </React.Fragment>
        ))}
    </List>
  );
};
